import { useEffect, useRef, useState } from "react";
import {
  getPendingTasks,
  subscribePendingTasks,
} from "@dhn/shared/pending-tasks";

// Evita un destello cuando el módulo nuevo ya tiene sus datos en caché.
export const MIN_VISIBLE_MS = 450;
// Espera breve sin trabajo pendiente: las consultas del módulo nuevo se
// disparan en sus efectos, justo después de montarse.
export const SETTLE_MS = 180;
// Una consulta colgada no debe bloquear la pantalla indefinidamente.
export const MAX_VISIBLE_MS = 10000;

const usePendingTasks = () => {
  const [pendingTasks, setPendingTasks] = useState(getPendingTasks);

  useEffect(() => subscribePendingTasks(setPendingTasks), []);

  return pendingTasks;
};

export default function useRouteChangeLoading(history) {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const startedAtRef = useRef(0);
  const { query, suspense } = usePendingTasks();

  useEffect(() => {
    let lastPathname = history.location.pathname;

    // Solo los cambios de ruta abren la carga; los cambios de query string o
    // hash pertenecen al mismo módulo.
    return history.listen((location) => {
      if (location.pathname === lastPathname) return;
      lastPathname = location.pathname;
      startedAtRef.current = Date.now();
      setIsTransitioning(true);
    });
  }, [history]);

  useEffect(() => {
    if (!isTransitioning) return undefined;

    const elapsed = Date.now() - startedAtRef.current;
    const finish = () => setIsTransitioning(false);
    const maxTimer = setTimeout(finish, Math.max(0, MAX_VISIBLE_MS - elapsed));
    const settleTimer =
      query || suspense
        ? null
        : setTimeout(finish, Math.max(SETTLE_MS, MIN_VISIBLE_MS - elapsed));

    return () => {
      clearTimeout(maxTimer);
      clearTimeout(settleTimer);
    };
  }, [isTransitioning, query, suspense]);

  return isTransitioning || suspense > 0;
}
